import Dashboard from 'pages/Dashboard'
import { Route, Routes, Navigate } from 'react-router-dom'
import { Markets } from 'pages/Markets'
import { Activity } from 'pages/Activity'
import { Rewards } from 'pages/Rewards'
import { Points } from 'pages/Points'
import { Multiply } from 'pages/Multiply'
import { useEffect } from 'react'
import { useAppDispatch } from 'state/hooks'
import { setViewPortfolioModalOpen } from 'state/slices/ui/form'

function ViewPortfolioRedirect() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Open the view portfolio modal when this component mounts
    dispatch(setViewPortfolioModalOpen())
  }, [dispatch])

  // Redirect to root page
  return <Navigate to="/" replace />
}

export function Routing() {
  const routes = (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/markets" element={<Markets />} />
      <Route path="/activity" element={<Activity />} />
      <Route path="/rewards" element={<Rewards />} />
      <Route path="/points" element={<Points />} />
      <Route path="/view" element={<ViewPortfolioRedirect />} />
      {/* <Route path="/multiply" element={<Multiply />} /> */}
    </Routes>
  )

  return routes
}
